import { render, staticRenderFns } from "./FabSubMenu.vue?vue&type=template&id=1ec4238b&scoped=true&"
import script from "./FabSubMenu.vue?vue&type=script&lang=js&"
export * from "./FabSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./FabSubMenu.vue?vue&type=style&index=0&id=1ec4238b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4238b",
  null
  
)

export default component.exports